import React, { FunctionComponent } from "react";

import HeroTitle from "../typography/HeroTitle";
import LeadText from "../typography/LeadText";
import TitleTag from "../typography/TitleTag";
import { twMerge } from "tailwind-merge";

type TextHeroProps = {
  wide?: boolean;
  extraWide?: boolean;
  dark?: boolean;
  tag: string;
  title: JSX.Element | string;
  description?: string | React.ReactNode;
  cta?: React.ReactNode;
  topCta?: React.ReactNode;
  center?: boolean;
};

const TextHero: FunctionComponent<TextHeroProps> = ({
  center = true,
  wide,
  extraWide,
  dark,
  tag,
  title,
  description,
  topCta,
  cta,
}) => {
  return (
    <div
      className={`w-full ${dark ? "bg-gray-900" : "bg-gray-100 dark:bg-gray-900"}`}
    >
      <section className="relative container px-5 py-12 md:py-24 lg:py-36 mx-auto">
        <div
          className={twMerge(
            "relative z-10 lg:px-7 flex flex-col ",
            center && "text-center items-center",
          )}
        >
          {topCta ?? <TitleTag>{tag}</TitleTag>}
          <HeroTitle dark={dark}>{title}</HeroTitle>
          {description && (
            <div
              className={twMerge(
                `mt-3`,
                "max-w-3xl",
                center && "md:mx-auto",
                wide && "max-w-5xl",
                extraWide && "max-w-none",
              )}
            >
              <LeadText dark={dark} className="prose prose-invert max-w-none">
                {description}
              </LeadText>
            </div>
          )}
          {cta}
        </div>

        <svg
          className={`hidden md:block absolute h-1/3 w-1/3 -top-12 right-0 xl:-right-9 ${
            dark ? "text-gray-700" : "text-gray-200 dark:text-gray-700"
          } opacity-70`}
        >
          <defs>
            <pattern
              id="squares-pattern"
              x="0"
              y="0"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                fill="currentColor"
                d="M6 18h12V6H6v12zM4 4h16v16H4V4z"
              ></path>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#squares-pattern)" />
        </svg>
        <svg className="hidden md:block absolute h-30 w-1/3 left:0 xl:-left-20 opacity-70">
          <rect width="100%" height="100%" fill="url(#squares-pattern)" />
        </svg>
      </section>
    </div>
  );
};

export default TextHero;
